export const arrayMove = (array, fromIndex, toIndex) => {
    const a = array.concat();
    const element = a[fromIndex];
    a.splice(fromIndex, 1);
    a.splice(toIndex, 0, element);
    return a;
};
